module.exports = __webpack_public_path__ + "img/funding-structure.471ce748.png";